/*
 * Module for the topic enable modal
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "underscore",
  "./topicEnableModalView",
  "modules/shared/treeList/treeListModule",
  "modules/shared/treeList/treeListModel",
  "modules/header/kbMenu/kbMenuModel",
  "modules/topicsSplit/topic/topicResponse/topicResponseModel",
], function (
  Marionette,
  Backbone,
  Messenger,
  _,
  TopicEnableModalView,
  TreeListModule,
  TreeListModel,
  KbMenuModel,
) {
  var TopicEnableModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "topicEnableModal";
      this.namespace = options.namespace;
      this.namespacePrefix = this.namespace ? this.namespace + ":" : "";
    },
    show: function (topic) {
      this.touchPoints = Messenger.reqres.request("kb:touchpoints");
      this.locales = Messenger.reqres.request("kb:languages");
      this.layout = new TopicEnableModalView.topicEnableModalLayout();
      this.root = this._buildModel(topic, this.touchPoints, this.locales);
      this.responsesList = this.addSubModule(
        new TreeListModule({
          region: this.layout.responseList,
          namespace: this.name,
        }),
      );

      this.layout.on(
        "done",
        function () {
          this.layout.hideError();
          var selectedResponses = Messenger.reqres.request(this.name + ":treeList:selected:nodes");
          if (selectedResponses.length === 0) {
            this.layout.hideWarning();
            //no responses selected
            this.layout.showError();
          } else {
            topic.conversation().selectedResponses = selectedResponses;
            Messenger.vent.trigger("close:modal");
            Messenger.vent.trigger(this.namespacePrefix + "enable:selected:responses");
          }
        },
        this,
      );
      this.layout.on(
        "cancel",
        function () {
          this.layout.hideError();
          Messenger.vent.trigger("close:modal");
          Messenger.vent.trigger(this.namespacePrefix + "cancel:enable:responses");
        },
        this,
      );
      this.layout.on(
        "selectAll",
        function () {
          Messenger.vent.trigger(this.name + ":treeList:select:all");
        },
        this,
      );
      this.layout.on(
        "deselectAll",
        function () {
          Messenger.vent.trigger(this.name + ":treeList:deselect:all");
        },
        this,
      );
      this.layout.on(
        "show",
        function () {
          this.layout.hideError();
          this._showSubViews();
        },
        this,
      );

      this.showRegion(this.layout);
    },
    _buildModel: function (topic, touchPoints, locales) {
      var responses = [];
      this._findResponses(topic.conversation(), responses);
      this.treeData = [];

      locales.forEach(function (locale) {
        var node = {
          name: locale.get("name"),
          data: locale.get("id"),
          nodes: [],
        };
        var languageId = locale.get("id");
        touchPoints.forEach(
          function (touchPoint) {
            var touchPointId = touchPoint.get("touchPointId");
            var response = _.find(responses, function (r) {
              return r.get("touchpointId") == touchPointId && r.get("languageId") == languageId;
            });
            if (response) {
              this.nodes.push({
                name: touchPoint.get("touchPoint"),
                data: languageId + "_" + touchPointId,
              });
            }
          },
          { nodes: node.nodes },
        );

        if (node.nodes.length > 0) {
          this.treeData.push(node);
        }
      }, this);
      return new TreeListModel.collection(this.treeData);
    },
    _findResponses: function (conversationModel, responses) {
      var responseTemplates = conversationModel.responseTemplates();
      responseTemplates.each(function (responseTemplate) {
        if (
          responseTemplate.get("statusId") != KbMenuModel.statuses.NON_VERSIONED_ENABLED &&
          !responseTemplate.isEmpty()
        ) {
          responses.push(responseTemplate);
        }
      });
      if (conversationModel.decisionCol) {
        conversationModel.decisionCol.each(function (decision) {
          this._findResponses(decision, responses);
        }, this);
      }
    },
    _showSubViews: function () {
      this.responsesList.show({ model: this.root });
    },
  });

  return TopicEnableModalController;
});
